import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

import { NgModule, ErrorHandler, Injectable } from '@angular/core';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgxMaskModule } from 'ngx-mask';
import { FrontModule } from './front/front.module';
import { ApiModule } from './api/api.module';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MatNativeDateModule } from '@angular/material/core';
// import * as Sentry from '@sentry/browser';
// import { environment } from 'src/environments/environment';
import { MetaModule } from './meta/meta.module';
import { JoyrideModule } from 'ngx-joyride';
import { LayoutModule } from './layout/layout.module';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { GeneralModule } from './general/general.module';

// try {
//   Sentry.init({
//     dsn: 'https://2a29fecb6eec4f8fbaf8a7147cb168e6@sentry.io/1537396',
//     release: environment.version
//   });
// } catch (error) {}

// @Injectable()
// export class SentryErrorHandler implements ErrorHandler {
//   constructor() {}
//   handleError(error) {
//     try {
//       Sentry.captureException(error.originalError || error);
//     } catch (error) {}
//   }
// }

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    GeneralModule,
    NoopAnimationsModule,
    MatNativeDateModule,
    NgxMaskModule.forRoot(),
    LoadingBarRouterModule,
    AppRoutingModule,
    LayoutModule,
    FrontModule,
    ApiModule,
    MetaModule,
    JoyrideModule.forRoot(),
  ],
  providers: [
    GoogleAnalyticsService
  ],
  // providers: [{ provide: ErrorHandler, useClass: environment.production ? SentryErrorHandler : ErrorHandler }],
  bootstrap: [AppComponent]
})
export class AppModule { }
